import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // useLayoutEffect (not useEffect) so the scroll reset is committed before
  // the browser paints the new route. Otherwise, navigating from a taller
  // page leaves the prior scroll offset in place for one frame, and the
  // shorter new page renders with its footer flashed near the top of the
  // viewport.
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
